import { FC } from 'react';
import { Box, Menu, MenuList, useDisclosure } from '@chakra-ui/react';
import MenuButton from '../shared/MenuButton';
import ListItem from '../shared/ListItem';
import { CaretRight } from 'components/Icons/Icons';
import useActiveLink from 'hooks/useActiveLink';
import { DropdownMenuLink, setOverlayStyles } from '../shared/StyledItems';
import { rgba } from 'polished';

interface Props {
  items: MenuItem[];
}

const highlightPadding = 16;

const MenuDropdown: FC<Props> = ({ items }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { activeLink, handleActiveLink } = useActiveLink();

  return items.length ? (
    <Box
      display={{ base: 'flex', xl: 'none' }}
      alignItems="center"
      ml="16px"
      sx={{
        _before: {
          ...setOverlayStyles(isOpen),
          opacity: { base: isOpen ? '0.2' : '0', lg: '0' },
        },
      }}
    >
      <Menu autoSelect={false} placement="bottom-end" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
        <MenuButton
          rightIcon
          fontSize="16px"
          isActive={!!activeLink}
          zIndex="1001"
          activeLinkHighlightPadding={highlightPadding}
          fontWeight={activeLink ? 500 : 400}
          color={rgba('white', 0.9)}
        >
          {activeLink || items[0].text}
        </MenuButton>
        <MenuList
          as="ul"
          p="20px 24px"
          w={{ base: '290px', lg: '350px' }}
          mt="27px"
          ml={activeLink ? `-${highlightPadding}px` : '0'}
          boxShadow={`0 4px 10px ${rgba('black', 0.1)}`}
          borderColor="transparent"
          zIndex="1001"
        >
          {items.map(item => (
            <ListItem as="li" key={item.id}>
              <DropdownMenuLink
                to={item.link.includes('toolkit') ? `${item.link}/embeddables` : item.link}
                isActive={(match: unknown) => handleActiveLink(item.text, match)}
                onClick={onClose}
              >
                {item.text}
                <CaretRight />
              </DropdownMenuLink>
            </ListItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  ) : null;
};

export default MenuDropdown;
